import { DropdownQueryParam } from 'clerk_common/constants/urls/queryParams';
import {
  parseAsArrayOf,
  parseAsString,
  useQueryState,
  useQueryStates,
} from 'nuqs';
import { DropdownFilterOption } from '../types';

export function listSelectedOptions(
  options: DropdownFilterOption,
  selectedIds: string[]
) {
  return listSelected(
    options.options,
    selectedIds,
    (o) => o.value,
    (o) => o.label
  );
}

interface NamedEntity {
  id: string;
  name: string;
}

export function listSelectedNamed(
  options: NamedEntity[],
  selectedIds: string[]
) {
  return listSelected(
    options,
    selectedIds,
    (o) => o.id,
    (o) => o.name
  );
}

export function listSelected<OptionT>(
  options: OptionT[],
  selectedIds: string[],
  getOptionId: (option: OptionT) => string,
  getOptionLabel: (option: OptionT) => string
): string[] {
  return options
    .filter((o) => selectedIds.includes(getOptionId(o)))
    .map((o) => getOptionLabel(o));
}

const useSelectedFilterIds = (category: DropdownQueryParam): string[] => {
  const [{ [category]: selectedIds }] = useQueryStates(
    {
      [category]: parseAsArrayOf(parseAsString),
    },
    {}
  );

  if (!selectedIds?.length) {
    return [];
  }

  const validSelectedIds = selectedIds.filter((id) => id !== '');

  if (validSelectedIds.length === 0) return [];

  return validSelectedIds;
};

export const useSelectedFilterValueWithDefault = (
  category: DropdownQueryParam,
  defaultValue: string
): number | undefined => {
  const [val] = useQueryState(category, {
    defaultValue,
  });

  if (val) {
    return parseInt(val);
  }

  return undefined;
};

export default useSelectedFilterIds;
